// COLORS
export const brandColor = '#6E19E6';
export const brandColorDarker = '#5814b8';
export const white = '#FFFFFF';
export const black = '#000000';
export const lightGrey = '#F7F7F7';
export const grey = '#F3F3F3';
export const darkGrey = '#9B9B9B';
export const textColor = black; // '#4A4A4A';
export const textColorLight = '#6A6A6A';
export const green = '#57C787';
export const yellow = '#FFD902';
export const lineColor = yellow;

// SIZES
export const phoneScreenMaxWidth = '767px';
export const largeScreenMinWidth = '992px';
export const extraLargeScreenMinWidth = '1441px';
export const remBase = 16;

// SPACING
export const yPadding = 75;
export const xPaddingXL = 190;
export const xPaddingDefault = 190;
export const xPaddingPhone = 25;



// WEBPACK FOOTER //
// ./src/styles/style-constants.js